import { render } from "./save-item-button.vue?vue&type=template&id=12ff9ff8"
import script from "./save-item-button.vue?vue&type=script&lang=js"
export * from "./save-item-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__